<template>
  <div class="p-contentplans-writing-user-headings-list--view">
    <UserHeadingsViewListItem
      v-for="item in items"
      :key="item.id"
      :level="item.level"
      :value="item.value"
    />
  </div>
</template>

<script>
import UserHeadingsViewListItem from '@/components/contentPlans/writing/UserHeadingsViewListItem';

export default {
  props: {
    h1: {
      type: String,
      required: true
    },
    headings: {
      type: Array,
      required: true
    }
  },
  components: {
    UserHeadingsViewListItem
  },
  computed: {
    items() {
      const items = [
        { id: 'h1', level: 'h1', value: this.h1 },
        ...this.headings
      ];
      return items.filter(item => item.value);
    }
  }
};
</script>
